export enum EncryptionType {
  base64 = 'Base64',
  //more encryption types in future
}
